import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT_CLIENT } from "../../../queries/user";

const Update = (props) => {
  return (
    <Mutation mutation={EDIT_CLIENT}>
      {updateUser => (
       <Form query_f = {updateUser} {...props} />
      )}
    </Mutation>
  );
};

export default Update;